import React from 'react'
import ModalDialog from '../../layouts/ModalDialog';
import EmptyState from '../../elements/EmptyState';
import { userDetails } from '../../../utils';
import AddEditBankDetails from './AddEditBankDetails';

const Detail = ({ label, value, mono = false }) => <div><p className='text-xs font-medium uppercase tracking-wider text-vcm-dark-gray'>{label}</p><p className={`mt-2 text-sm font-medium text-gray-900 ${mono ? 'font-orbitron tracking-wide' : ''}`}>{value || <span className='text-gray-400'>Not provided</span>}</p></div>

const StaffBankDetails = ({ staff }) => {
  const bank = staff?.bankDetails

  const currentStaffLoggedIn = staff?._id === userDetails()?.staffMemberProfile;

  const [updatingBankInfo, setUpdatingBankInfo] = React.useState(false);
  
  return (
    <>
      <section className='overflow-hidden'>
        <div className='border-b border-gray-100 px-2 py-2 flex items-start justify-between gap-2'>
          <div className='flex flex-col gap-1'>
            <h2 className='font-space-grotesk text-lg font-semibold text-gray-900'>Bank details</h2>
            <p className='mt-1 text-sm text-vcm-dark-gray'>Account information recorded for this staff member.</p>
          </div>
          {currentStaffLoggedIn && <button onClick={()=>{setUpdatingBankInfo(true)}} className="text-xs font-semibold font-space-grotesk text-gray-600 rounded-lg bg-gray-200 hover:bg-gray-300 transition duration-200 px-4 py-3">Update Bank Details</button>}
        </div>
        {bank ? 
          <div className='grid grid-cols-1 gap-x-6 gap-y-6 p-5 sm:grid-cols-2 xl:grid-cols-3'>
            <Detail label='Bank name' value={bank.bank} />
            <Detail label='Account name' value={bank.accountName} />
            <Detail label='Account number' value={bank.accountNumber} mono />
            {/* <Detail label='Sort code' value={bank.sortCode} mono />{bank.nationalInsuranceNumber && 
            <Detail label='National insurance number' value={bank.nationalInsuranceNumber} mono />} */}
          </div>
          : 
          <EmptyState emptyStateTitle="No bank details available" emptyStateText="Bank account information will appear here when it is added." />
        }
      </section>

      <ModalDialog
        shown={updatingBankInfo} 
        closeFunction={()=>{setUpdatingBankInfo(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Update bank details'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        
        <AddEditBankDetails staff={staff} close={()=>{setUpdatingBankInfo(false)}} reload={()=>{window.location.reload()}} />
      </ModalDialog>
    </>
  )
}

export default StaffBankDetails
